import {
  BulletedList,
  Grid,
  IconToggle,
  ThemeProvider,
} from '@sparemin/blockhead';
import React from 'react';
import { headerBlock as block } from '../../utils';
import { useClipSelect } from '../ClipSelectContext';
import { useClipSelectNavigation } from '../ClipSelectNavigationContext';

export type ClipSelectViewToggleProps = {};

const ClipSelectViewToggle: React.FC<ClipSelectViewToggleProps> = () => {
  const { visibleSuggestionIds, onSuggestionSelect } = useClipSelect();
  const [state, send] = useClipSelectNavigation();

  return (
    <ThemeProvider theme="flip">
      <IconToggle
        aria-label="activate detail view"
        unselectedIcon={<Grid width={15} height={15} />}
        selectedIcon={<BulletedList width={15} height={15} />}
        isSelected={state.matches('select.browse')}
        className={block('view-toggle', {
          hidden: state.matches('edit.transcript'),
        })}
        onChange={isSelected => {
          send({
            type: !isSelected ? 'DETAIL_VIEW_OPEN' : 'DETAIL_VIEW_CLOSE',
          });
          onSuggestionSelect(isSelected ? null : visibleSuggestionIds[0]);
        }}
      />
    </ThemeProvider>
  );
};

export default ClipSelectViewToggle;
